import {
  faLinkedinIn,
  faGithub
} from "@fortawesome/free-brands-svg-icons";
import { faInbox } from "@fortawesome/free-solid-svg-icons"
const social = [
  {
    account: "E-mail",
    profileURL: "mailto:leigh.ann.friedel@gmail.com",
    icon: faInbox
  },
  {
    account: "LinkedIn",
    profileURL: "https://www.linkedin.com/in/leigh-ann-friedel/",
    icon: faLinkedinIn
  },
  {
    account: "GitHub",
    profileURL: "https://github.com/lafriedel/",
    icon: faGithub
  },
];

export default social;
